export const Namings = () => import('components/Pages/Content/Namings')
export const SeoData = () => import('components/Pages/Content/SeoData')
export const Other = () => import('components/Pages/Content/Other')
export const MetaTags = () => import('components/Pages/Content/MetaTags')
